import { getCascadeValues } from "../api/Validations";
import { CascadeValue } from "../models/analysiscodes/AnalysisCodes";

export const getStoreAccountCascadeValues = async (parentFields: string[]) => {
  const response = await getCascadeValues();
  const cascadeValues: CascadeValue[] = response.data;
  let cascadeData: { [key: string]: CascadeValue[] } = {};
  parentFields.forEach((p) => {
    const filteredValues =
      cascadeValues?.filter((validValue) => {
        return getParentFieldMappings(p).some(
          (f) => f.toLowerCase() === validValue.ParentField.toLowerCase()
        );
      }) || [];

    cascadeData = { ...cascadeData, [p]: filteredValues };
  });
  return cascadeData;
};

export const getParentFieldMappings = (field: string) => {
  const fields = [field];
  if (field === "MechanicalIntegrity") fields.push("MechIntegrity");
  else if (field === "MechIntegrity") fields.push("MechanicalIntegrity");
  return fields;
};
